module.exports = __webpack_public_path__ + "img/sticker_digital3-laodl-1400x400.f943c7f9.jpg";